module.exports = __webpack_public_path__ + "assets/img/Type E (2).049f239f.jpg";